module.exports = __webpack_public_path__ + "img/info-prod.85b3dba3.svg";